import translate from '@logistics-frontend/core/i18n/translate'
import {window} from '@logistics-frontend/utils'

import {appConfig} from './app-config'
import {__I18N_KEY__} from './consts'

export const i18n = translate(appConfig.lang || 'ru', window ? window[__I18N_KEY__] : {})
